module.exports = __webpack_public_path__ + "static/media/global-shoppng-21.ce53dcb2.png";